import React, { useEffect, useState } from "react";
import CustomerLayout from "../layouts/CustomerLayout";
import CustomerTopdesk from "../components/CustomerTopdesk";

const Customer = () => {
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    const path = window.location.pathname;

    const companyNameFromUrl = decodeURIComponent(path.split("/customer/")[1]);

    setCompanyName(companyNameFromUrl);
  }, []);

  return (
    <>
      <div className="flex">
        <div className="w-full">
          
            {/* Title */}
            <h1 className="ml-[5%] mt-[3%] mb-[3%] text-[4vh]">
              {companyName}
            </h1>
            {/* <CustomerTopdesk name={companyName} /> */}
          

          {/* Content */}
       
            {companyName.trim() !== "" && <CustomerLayout name={companyName} />}
          
        </div>
      </div>
    </>
  );
};

export default Customer;
